<template>
  <div>
    <div class="geek-notice" :class="{show:$store.state.isMsg}">
      <div class="geek-notice-main">
        <img src="../assets/images/msg.png" class="geek-notice-main-icon" alt="">
        <div class="geek-notice-cont">
          <div class="geek-notice-cont-title">系统消息</div>
          <div class="geek-notice-cont-html" v-html="msg"></div>
          <div class="geek-notice-cont-btn">


            <Button size="small" @click="closeHide">一周内不再显示</Button>
            <Button type="primary" size="small" style="width:80px;margin-left:10px" @click="close">关闭</Button>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import cookie from "@/utils/store/cookie";
  export default {
    props: ['msg'],
    data() {
      return {}
    },

    methods: {
      close() {
        this.$store.state.isMsg = false
      },
      closeHide() {
        cookie.set("isMsg", "false", 7);
        this.$store.state.isMsg = false
      }


    }
  }
</script>

<style lang="less" scoped>
  .geek-notice {
    padding: 16px;
    border-radius: 4px;
    -webkit-box-shadow: 0 1px 6px rgba(0, 0, 0, .2);
    box-shadow: 0 1px 6px rgba(0, 0, 0, .2);
    background: #fff;
    line-height: 1;
    position: fixed;
    z-index: 1015;
    transition: all 0.5s;
    right: -400px;
    top: 24px;
    width: 335px;
    min-height: 100px;

    .geek-notice-main {
      position: relative;

      .geek-notice-main-icon {
        position: absolute;
        left: 0;
        top: 0;
        width: 45px;
        height: 45px;
      }

      .geek-notice-cont {
        margin-left: 60px;

        .geek-notice-cont-title {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 5px;
        }

        .geek-notice-cont-html {
          font-size: 16px;
          line-height: 20px;
        }

        .geek-notice-cont-btn {
          margin-top: 10px;
        }
      }
    }

  }

  .show {
    right: 20px;
  }

  .hide {
    right: -400px;
  }
</style>